(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-popup"] && !Shopify.designMode) return;
  try {
    
    (function () {
      const popup = document.querySelector('[data-promo-popup]');
      if (!popup) return;

      const campaignId = popup.dataset.campaignId || 'default';
      const delayMs = Math.max(0, parseInt(popup.dataset.delay, 10) || 0) * 1000;
      const frequencyDays = Math.max(0, parseInt(popup.dataset.frequencyDays, 10) || 0);
      const storageKey = 'auma_promo_dismissed';

      let lastFocused = null;

      function isDesignMode() {
        // Always show in the theme editor so the merchant can see their edits.
        return window.Shopify && window.Shopify.designMode;
      }

      function shouldShow() {
        if (isDesignMode()) return true;
        let record;
        try {
          record = JSON.parse(window.localStorage.getItem(storageKey) || '{}');
        } catch (e) {
          record = {};
        }
        // Different campaign than the one last dismissed → show again.
        if (record.campaign !== campaignId) return true;
        // Same campaign, but the "show again after" window has passed.
        if (frequencyDays > 0 && record.ts) {
          const elapsedDays = (Date.now() - record.ts) / 86400000;
          return elapsedDays >= frequencyDays;
        }
        // frequencyDays === 0 means "once per campaign" → already dismissed.
        return false;
      }

      function open() {
        lastFocused = document.activeElement;
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        const closeBtn = popup.querySelector('[data-promo-popup-close]');
        if (closeBtn && closeBtn.focus) closeBtn.focus();
      }

      function close() {
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        try {
          window.localStorage.setItem(storageKey, JSON.stringify({ campaign: campaignId, ts: Date.now() }));
        } catch (e) { /* private mode — fail quietly */ }
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      }

      popup.addEventListener('click', function (e) {
        if (e.target.closest('[data-promo-popup-close]')) close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') close();
      });

      if (shouldShow()) {
        window.setTimeout(open, isDesignMode() ? 0 : delayMs);
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
